export default __webpack_public_path__ + "static/media/TermsBma.624f451b.docx";